<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="solicitud"
  >
    <main-breadcrumb
      :items="items"
      showBackButton
    ></main-breadcrumb>
    <main-buttons-bar :align="'space-between'">
      <template #left>
        <custom-title>Listado de solicitudes</custom-title>
      </template>
      <template #right>
        <template v-if="!canEdit">
          <el-tooltip
            content="El usuario no posee permisos de edición"
            placement="top"
          >
            <el-button
              type="primary"
              size="default"
              :icon="IconAdd"
              disabled
            >
              Nueva solicitud
            </el-button>
          </el-tooltip>
        </template>

        <template v-else>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            @click="() => (modalVisible = true)"
          >
            Nueva solicitud
          </el-button>

          <modal-select-product-type
            v-model="modalVisible"
            title="Nueva solicitud"
            url="/page/requests/edit"
            @close-modal="() => (modalVisible = false)"
          />
        </template>
      </template>
    </main-buttons-bar>
    <request-filters />
    <custom-table
      :requestApi="findAllSolicitudesHTTP"
      :requestArgs="filters"
      :pathEdit="'/page/requests/edit'"
      :paramId="'Codigo'"
      :data="solicitudes"
      :columns="columns"
      :showDetailButton="false"
      :firstLoad="false"
      :fixedActions="'right'"
    >
      <template #custom-actions="{ row }">
        <el-tooltip
          v-if="!canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            :icon="IconContentCopy"
            disabled
            size="small"
          />
        </el-tooltip>
        <el-button
          v-else
          :icon="IconContentCopy"
          size="small"
          @click.prevent="cloneRequest(row)"
        />
        <!-- <el-button :icon="IconCheck" size="small" @click.prevent="priceConfirmationFromRequest(row)"></el-button> -->
      </template>
    </custom-table>
    <modal-clone-request
      v-if="modalVisibleCloneRequest"
      v-model="modalVisibleCloneRequest"
      :selectedRow="selectedCloneRow"
      @closed="modalVisibleCloneRequest = false"
      @cloned="onCloned"
    ></modal-clone-request>
    <modal-price-confirmation
      v-if="modalVisiblePriceConfirmationFromRequest"
      v-model="modalVisiblePriceConfirmationFromRequest"
      :selectedRow="selectedPriceFromRequestRow"
      @closed="handleModalPriceConfirmationFromRequest"
    ></modal-price-confirmation>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useRequestStore } from '../stores/request_store.js';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import IconAdd from '~icons/mdi/add';
import ModalSelectProductType from '@/shared/components/modal_select_product_type.vue';
import RequestFilters from './request_filters.vue';
import IconContentCopy from '~icons/mdi/content-copy';
import PermissionGate from '@/shared/components/permission_gate.vue';
import ModalCloneRequest from './modal_clone_request.vue';
import ModalPriceConfirmation from '../../prices/prices_list/modal_price_confirmation.vue';

const requestStore = useRequestStore();
const { solicitudes, solicitud, filters } = storeToRefs(requestStore);
const {
  firstRequest,
  resetFilter,
  resetSolicitud,
  findAllSolicitudesHTTP,
  findSolicitudPorCodigoHTTP,
  setPage,
  emptyList,
} = requestStore;
const modalVisible = ref(false);
const selectedCloneRow = ref(null);

const modalVisibleRequest = ref(false);
const modalVisibleCloneRequest = ref(false);
// local state
const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const columns = [
  { field: 'Codigo', label: 'ID', width: 100, sortable: true, isVisible: true },
  {
    field: 'FechaCreacion',
    label: 'Fecha solicitud',
    width: 120,
    sortable: true,
    isVisible: true,
    isDate: true,
  },
  { field: 'Cliente', label: 'Cliente', width: 280, sortable: true, isVisible: true },
  { field: 'Producto', label: 'Producto', width: 250, sortable: true, isVisible: true },
  {
    field: 'Cantidad',
    label: 'Cantidad',
    width: 140,
    sortable: true,
    isVisible: true,
    isNumber: true,
    precision: 0,
  },
  { field: 'UnidadVenta', label: 'Unidad Venta', width: 130, sortable: true, isVisible: true },
  {
    field: 'CodigosEquivalentes',
    label: 'Código Equivalente',
    width: 180,
    sortable: true,
    isVisible: true,
  },
  {
    field: 'CodigosAdicionales',
    label: 'Código adicional',
    width: 180,
    sortable: true,
    isVisible: true,
  },
  { field: 'Estado', label: 'Estado', width: 120, sortable: true, isVisible: true },
  {
    field: 'FechaEstado',
    label: 'Fecha estado',
    width: 120,
    sortable: true,
    isVisible: true,
    isDate: true,
  },
  { field: 'TipoProducto', label: 'Tipo producto', width: 220, sortable: false, isVisible: true },
];

onBeforeMount(async () => {
  resetFilter();
  resetSolicitud();
  firstRequest();
});

const cloneRequest = async (row) => {
  if (row.Codigo && +row.Codigo > 0) {
    await findSolicitudPorCodigoHTTP(row.Codigo);
    selectedCloneRow.value = JSON.parse(JSON.stringify(solicitud.value));
    modalVisibleCloneRequest.value = true;
  }
};

const onCloned = async (_resp) => {
  setPage(1);
  emptyList();
  await findAllSolicitudesHTTP();
  modalVisibleCloneRequest.value = false;
};
</script>

<style scoped></style>
